import { ROUTE } from './routes';

export const BREADCRUMBS_DATA = {
  ENTER: [
    { title: 'breadCrumbs:main', to: ROUTE.HOME },
    { title: 'breadCrumbs:enter', to: ROUTE.AUTH.SIGNIN, active: true },
  ],
  FORGOT_PASSWORD: [
    { title: 'breadCrumbs:main', to: ROUTE.HOME },
    { title: 'breadCrumbs:enter', to: ROUTE.AUTH.SIGNIN },
    { title: 'breadCrumbs:forgotPassword', to: ROUTE.AUTH.FORGOT_PASSWORD, active: true },
  ],
  TWO_FA: [
    { title: 'breadCrumbs:main', to: ROUTE.HOME },
    { title: 'breadCrumbs:enter', to: ROUTE.AUTH.SIGNIN },
    { title: 'breadCrumbs:2fa', to: ROUTE.AUTH.TWO_FA, active: true },
  ],
  ERROR: [
    { title: 'breadCrumbs:main', to: ROUTE.HOME },
    { title: 'breadCrumbs:error', to: ROUTE.WITHDRAWAL.ERROR, active: true },
  ],
  WITHDRAWAL: [
    { title: 'breadCrumbs:main', to: ROUTE.HOME },
    { title: 'breadCrumbs:fundsWithdrawal', to: ROUTE.WITHDRAWAL.SUCCESS, active: true },
  ],
  CONTACTS: [
    { title: 'breadCrumbs:main', to: ROUTE.HOME },
    { title: 'breadCrumbs:contacts', to: ROUTE.CONTACTS, active: true },
  ],
  PRIVACY_POLICY: [
    { title: 'breadCrumbs:main', to: ROUTE.HOME },
    { title: 'breadCrumbs:documentation', to: ROUTE.PRIVACY_POLICY, active: true },
  ],
  MARKETS: [
    { title: 'breadCrumbs:main', to: ROUTE.HOME },
    { title: 'breadCrumbs:markets', to: ROUTE.MARKETS.MARKETS, active: true },
  ],
  TRADING_SESSIONS: [
    { title: 'breadCrumbs:main', to: ROUTE.HOME },
    { title: 'breadCrumbs:platform', to: ROUTE.PLATFORM },
    { title: 'breadCrumbs:tradingSession', to: ROUTE.MARKETS.TRADING_SESSION, active: true },
  ],
  INSTRUMENTS: [
    { title: 'breadCrumbs:main', to: ROUTE.HOME },
    { title: 'breadCrumbs:platform', to: ROUTE.PLATFORM },
    { title: 'breadCrumbs:instruments', to: ROUTE.MARKETS.INSTRUMENTS, active: true },
  ],
  PLATFORM: [
    { title: 'breadCrumbs:main', to: ROUTE.HOME },
    { title: 'breadCrumbs:platform', to: ROUTE.PLATFORM, active: true },
  ],
  ABOUT_COMPANY: [
    { title: 'breadCrumbs:main', to: ROUTE.HOME },
    { title: 'breadCrumbs:aboutCompany', to: ROUTE.ABOUT_COMPANY, active: true },
  ],
};
